import { getCaptureStartParams } from './params/getCaptureStartParams';
import { fetchAccessToken } from 'components/shared/XpressId/services';
import { getErrorFromStartResponse } from './responses/getErrorFromStartResponse';

export const startCapture = async ({ acceptedText, faceMatch }, { onComplete, onError }) => {
    const params = getCaptureStartParams({ acceptedText, faceMatch });
    const { ok, data } = await fetchAccessToken(params);
    const error = getErrorFromStartResponse({ ok, data });
    if (error) return onError(error);

    return onComplete(data);
};
